import { toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6e941fb8")

_pushScopeId("data-v-6e941fb8")
const _hoisted_1 = { class: "playback-speed" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("span", {
      "aria-label": `${_ctx.translateLabels('playback speed')}`,
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleSpeedList && _ctx.toggleSpeedList(...args)))
    }, _toDisplayString(_ctx.currentSpeed) + "x", 9, ["aria-label"]),
    _createVNode("ul", {
      class: "speed-list",
      ref: "speedListRef",
      onMouseleave: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.hoverOutSpeedList && _ctx.hoverOutSpeedList(...args)))
    }, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.speedValues, (speed) => {
        return (_openBlock(), _createBlock("li", {
          key: speed,
          onClick: ($event: any) => (_ctx.changeSpeed(speed)),
          class: _ctx.currentSpeed == speed ? 'selected-playback-speed' : '',
          "aria-label": `${speed}x`
        }, _toDisplayString(speed) + "x ", 11, ["onClick", "aria-label"]))
      }), 128))
    ], 544)
  ]))
})